package org.example.zone360.pages.dashboard.coaches

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaTriangleExclamation
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.components.CommonButton
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachLimitReachedPopup(
    onDialogDismiss: () -> Unit,
    breakpoint: Breakpoint,
    onClick: () -> Unit,
    sitePalette: SitePalette
){

    Box(
        modifier = Modifier.fillMaxSize()
            .position(Position.Fixed)
            .zIndex(999)
            .backgroundColor(Colors.Black.copyf(alpha = 0.5f)),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(if (breakpoint < Breakpoint.MD) 90.percent else 475.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .boxShadow(blurRadius = 32.px, color = Colors.Black.copyf(alpha = 0.25f))
                .padding(24.px)
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                // Icon and title
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Box(
                        modifier = Modifier
                            .size(40.px)
                            .backgroundColor(Colors.Red.copyf(alpha = 0.1f))
                            .borderRadius(100.percent)
                            .display(DisplayStyle.Flex)
                            .justifyContent(JustifyContent.Center)
                            .alignItems(AlignItems.Center),
                        contentAlignment = Alignment.Center
                    ) {
                        FaTriangleExclamation(size = IconSize.LG,
                            modifier = Modifier.color(sitePalette.primary.rgb)
                        )
                    }

                    FieldTitleTextNormalSimple(
                        "Users Limit Reached",
                        fontSize = 20.px,
                        fontWeight = 500,
                        width = 250.px,
                        marginLeft = 10.px,
                    )
                }

                FieldTitleTextNormalSimple(
                    "${AppGlobal.userData.organization.replaceFirstChar { it.uppercase() }} has reached maximum limit coaches Allowed. Do you want to increase the limit of coaches",
                    fontSize = 14.px,
                    color = Colors.Gray,
                    marginBottom = 10.px,
                    marginLeft = 50.px
                )

                Row(
                    modifier = Modifier.fillMaxWidth().gap(10.px),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.End
                ) {
                    CommonButton(
                        text = "Yes",
                        onCLick = {
                                  onClick()
                        },
                        width = 60.px,
                        height = 39.px,
                    )

                    CommonButton(
                        text = "No",
                        onCLick = {
                                  onDialogDismiss()
                        },
                        width = 60.px,
                        height = 39.px,
                    )
                }
            }
        }
    }
}